import type { Dispatch, SetStateAction } from "react";
import ArrowIcon from "@/assets/icons/arrow.svg?react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type PaginationProps = {
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  isPreviousDisabled: boolean;
  isNextDisabled: boolean;
  count: number;
  pages: (string | number)[];
};
function Pagination({
  currentPage,
  setCurrentPage,
  isPreviousDisabled,
  isNextDisabled,
  pages,
  count,
}: PaginationProps) {
  if (count === 0) {
    return null;
  }
  return (
    <div className="mt-3 flex items-center self-end rounded-lg border border-solid border-gray-300">
      <Button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((prevState) => prevState - 1)}
        variant="ghost"
        className="flex items-center gap-2 rounded-none"
      >
        <ArrowIcon className={cn(isPreviousDisabled && "stroke-gray-300")} />
        Previous
      </Button>
      {pages.map((pageNumber) => {
        return (
          <Button
            onClick={() => typeof pageNumber !== "string" && setCurrentPage(pageNumber)}
            className={cn("rounded-none", pageNumber === currentPage ? "bg-gray-300" : "")}
            variant="ghost"
            key={pageNumber}
          >
            {pageNumber}
          </Button>
        );
      })}
      <Button
        onClick={() => setCurrentPage((prevState) => prevState + 1)}
        disabled={isNextDisabled}
        variant="ghost"
        className="flex items-center gap-2 rounded-none"
      >
        Next
        <ArrowIcon className={cn("rotate-180", isNextDisabled && "stroke-gray-300")} />
      </Button>
    </div>
  );
}

Pagination.displayName = "Pagination";

export { Pagination };
